


































































































































import Vue from 'vue';
import ItemInput from '@/components/item/ItemInput.vue';
import ItemTooltip from '@/components/item/ItemTooltip.vue';
import AirStatusResultBar from '@/components/result/AirStatusResultBar.vue';
import PlaneDetailResult from '@/components/result/PlaneDetailResult.vue';
import ContactRates from '@/components/result/ContactRates.vue';
import Airbase from '@/classes/airbase/airbase';
import Const, { AB_MODE } from '@/classes/const';
import Item from '@/classes/item/item';
import SiteSetting from '@/classes/siteSetting';

export default Vue.extend({
  components: {
    ItemInput,
    AirStatusResultBar,
    ItemTooltip,
    PlaneDetailResult,
    ContactRates,
  },
  name: 'Airbase',
  props: {
    handleShowItemList: {
      type: Function,
      required: true,
    },
    value: {
      type: Airbase,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isDefense: {
      type: Boolean,
      required: true,
    },
    handleShowItemPresets: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    tab: 'detail',
    wave1: 0,
    wave2: 0,
    modes: Const.AB_MODE_ITEMS,
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipItem: new Item(),
    tooltipX: 0,
    tooltipY: 0,
    destroyDialog: false,
    detailDialog: false,
    visibleResource: false,
  }),
  computed: {
    airbase(): Airbase {
      return this.value;
    },
    airPower() {
      if (this.isDefense && this.value.mode === AB_MODE.DEFENSE) {
        return this.value.defenseAirPower;
      }
      return this.value.fullAirPower;
    },
    airPowerDetail() {
      if (this.isDefense && this.value.mode === AB_MODE.DEFENSE) {
        const airPowers = this.value.items.map((v) => v.defenseAirPower);
        return airPowers.filter((v) => v > 0).length ? `( ${airPowers.join(' | ')} )` : '';
      }
      const airPowers = this.value.items.map((v) => v.fullAirPower);
      return airPowers.filter((v) => v > 0).length ? `( ${airPowers.join(' | ')} )` : '';
    },
    reconCorrString() {
      return this.value.mode === AB_MODE.BATTLE && this.value.reconCorr > 1 ? `${this.value.reconCorr}` : '';
    },
    reconCorrDefString() {
      return this.value.mode === AB_MODE.DEFENSE && this.value.reconCorrDefense > 1 ? `${this.value.reconCorrDefense}` : '';
    },
    resultStateRate() {
      const wave1 = this.value.resultWave1;
      const wave2 = this.value.resultWave2;
      return [Math.floor(wave1.rates[wave1.airState.value]), Math.floor(wave2.rates[wave2.airState.value])];
    },
    resultLabel() {
      const wave1State = this.value.resultWave1.airState;
      const wave2State = this.value.resultWave2.airState;
      return [wave1State.text, wave2State.text];
    },
    resultBarValue() {
      return [this.value.resultWave1.airStateBarWidth, this.value.resultWave2.airStateBarWidth];
    },
    hasItem() {
      return this.value.items.some((v) => v.data.id > 0);
    },
    enabledDetail() {
      return this.value.mode === AB_MODE.BATTLE && this.value.items.some((v) => v.data.id > 0);
    },
  },
  methods: {
    updateItem() {
      this.setAirbase();
    },
    setAirbase(value?: Airbase) {
      this.clearTooltip();
      if (value === undefined) {
        this.$emit('input', new Airbase({ airbase: this.airbase }));
      } else {
        this.$emit('input', value);
      }
    },
    showItemList(index: number) {
      this.clearTooltip();
      this.handleShowItemList(this.index, index);
    },
    resetItems(): void {
      this.setAirbase(new Airbase());
    },
    viewDetail(): void {
      this.destroyDialog = false;
      this.detailDialog = true;
    },
    closeDetail() {
      this.detailDialog = false;
      setTimeout(() => {
        this.destroyDialog = true;
      }, 100);
    },
    toggleDetailDialog() {
      if (!this.detailDialog) {
        this.closeDetail();
      } else {
        this.destroyDialog = false;
      }
    },
    showItemPresets() {
      this.handleShowItemPresets(this.index);
    },
    bootTooltip(item: Item, e: MouseEvent) {
      const setting = this.$store.state.siteSetting as SiteSetting;
      if (!item.data.id || setting.disabledItemTooltip) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('item-name')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = rect.x + rect.width / 3;
        this.tooltipY = rect.y + rect.height;
        this.tooltipItem = item;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
